import ticketsAPI from "@/api/tickets";
import moment from 'moment';

const getDefaultState = () => ({
  pageType: 'tickets',
  currentUser: '',
  ticketsConfig: {
    pagination: {
      page: null,
      limit: null,
      sort: null,
      order: null,
    },
    queryParams: {
      kind__in: null,
      status__in: null,
      agent__in: null,
      escalation_agent__in: null,
      team__in: null,
      cause__in: null,
      creation_timestamp__gte: null,
      creation_timestamp__lte: null,
      product_id: null,
      supplier_ticket_id: null,
    },
    paginationCount: 0,
  },
  tickets: [],
  ticketsLoading: true,
  ticketThread: {},
  ticketsError: [],
  ticketFilters: {},
  ticketFiltersLoading: false,
  newTicketID: '',
  currentTicket: {},
  currentTicketLoading: false,
  currentTicketNotes: [],
  currentTicketNotesLoading: false,
  currentTicketNotesError: false,

  ticketUpdateLoading: false,
  
  isAddTicketNoteLoading: false,
  isAddTicketNoteError: false,
  addTicketNoteResponse: '',
});

const state = getDefaultState();

const mutations = {
  setNewTicketID(state,data){
    state.newTicketID = data;
    state.ticketUpdateLoading = false;
  },
  setCurrentTicket(state,data){
    state.currentTicket = data;
    state.currentTicketLoading = false;
    state.ticketUpdateLoading = false;
  },
  setCurrentTicketLoading(state,data){state.currentTicketLoading = data;},
  setCurrentTicketNotes(state,data){
    state.currentTicketNotes = data;
    state.currentTicketNotesLoading = false;
  },
  setCurrentTicketNotesLoading(state,data){state.currentTicketNotesLoading = data;},
  setCurrentTicketNotesError(state, data) {
    state.currentTicketNotesError = data;
  },
  setTicketUpdateLoading(state,data){state.ticketUpdateLoading = data;},
  setPageType(state,data){state.pageType = data;},
  setCurrentUser(state,data){state.currentUser = data;},
  setTicketFilters(state,data){
    state.ticketFilters = data;
    state.ticketFiltersLoading = false;
  },
  setTicketFiltersLoading(state,data){ state.ticketFiltersLoading = data; },

  UPDATE_TICKETS_PAGINATION(state, { pagination, queryParams }) {
    if(pagination) {
      for(let param in state.ticketsConfig.pagination) {
        if(pagination[param]) {
          state.ticketsConfig.pagination[param] = pagination[param];
        }
      }
    }
    
    if(queryParams) {
      for(let param in state.ticketsConfig.queryParams) {
        if(queryParams.hasOwnProperty(param)) {
          if(param.includes("__in") && typeof queryParams[param] === "string") {
            state.ticketsConfig.queryParams[param] = queryParams[param].split(",");
          } else {
            state.ticketsConfig.queryParams[param] = queryParams[param];
          }
        }
      }
    }
  },

  SET_TICKETS(state, payload) {
    state.tickets = payload.data;
    state.ticketsConfig.paginationCount = parseInt(payload.headers['pagination-count']);
    state.ticketsConfig.pagination.limit = parseInt(payload.headers['pagination-limit']);
    state.ticketsConfig.pagination.page = parseInt(payload.headers['pagination-page']);
    state.ticketsLoading = false;
  },
  SET_TICKETS_LOADING(state, id) {
    state.ticketsLoading = true;
    let ticketThread = {};
    ticketThread[id] = true;
    state.ticketThread = ticketThread;
  },
  SET_TICKETS_ERROR(state, payload) {
    state.ticketsLoading = false;
    state.ticketsError = payload;
  },
  RESET_TICKET_STORE(state) {
    Object.assign(state, getDefaultState());
  },

  CREATE_TICKET_NOTE_BEGIN(state) {
    state.isAddTicketNoteLoading = true;
    state.isAddTicketNoteError = false;
    state.addTicketNoteResponse = null;
  },
  CREATE_TICKET_NOTE_SUCCESS(state) {
    state.isAddTicketNoteLoading = false;
  },
  CREATE_TICKET_NOTE_ERROR(state, err) {
    state.isAddTicketNoteLoading = false;
    state.isAddTicketNoteError = true;
    state.addTicketNoteResponse = err;
  }
};

const actions = {
  async updateTicketsPagination({ commit, dispatch }, payload) {
    commit("UPDATE_TICKETS_PAGINATION", payload);
    dispatch("fetchTickets");
  },
  async updateDashboardTicketsPagination({ commit, dispatch }, payload) {
    commit("UPDATE_TICKETS_PAGINATION", payload);
    dispatch("fetchDashboardTickets");
  },
  async fetchTicketFilters({ commit }) {
    commit("setTicketFiltersLoading", true);
    try {
      let res = await ticketsAPI.fetchTicketFilters();
      commit("setTicketFilters", res.data);
    } catch(err) {
      commit("setTicketFiltersLoading", false);
    }
  },

  async fetchTickets({ state, commit }) {
    const id = moment().valueOf();
    let res;

    const url = new URL(window.location);
    const query = {};

    Object.entries({ ...state.ticketsConfig.pagination, ...state.ticketsConfig.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
        url.searchParams.set(k,v);
      } else {
        url.searchParams.delete(k);
      }
    });

    window.history.pushState(null, '', url.toString());
    localStorage.setItem('ticket-filters', JSON.stringify({ date: moment(), ...query }));

    try {
      commit('SET_TICKETS_LOADING', id);
      res = await ticketsAPI.fetchTickets(query);
    } catch(err) {
      commit("SET_TICKETS_ERROR", err);
    }

    if (res && state.ticketThread[id]) {
      commit("SET_TICKETS", res);
    }
  },

  async fetchDashboardTickets({ state, commit }) {
    const id = moment().valueOf();
    let res;
    let query = {};
    
    Object.entries({ ...state.ticketsConfig.pagination, ...state.ticketsConfig.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
      }
    });

    try {
      commit('SET_TICKETS_LOADING', id);
      res = await ticketsAPI.fetchTickets(query);
    } catch(err) {
      commit("SET_TICKETS_ERROR", err);
    }

    if (res && state.ticketThread[id]) {
      commit("SET_TICKETS", res);
    }
  },

  async fetchTicketByID({ commit,dispatch },tID) {
    try {
      commit('setCurrentTicketLoading',true);
      let res = await ticketsAPI.fetchTicketByID(tID);
      commit('setCurrentTicket', res.data);
    } catch(err) {
      commit('setCurrentTicketLoading',false);
      dispatch('alerts/setAlert', {type: 'error',message: err.response.data.message}, { root: true });
    }
  },
  async fetchTicketNotesByID({ commit,dispatch },tID) {
    try {
      commit('setCurrentTicketNotesLoading',true);
      let res = await ticketsAPI.fetchTicketNotesByID(tID);
      commit('setCurrentTicketNotes', res.data);
    } catch(err) {
      commit('setCurrentTicketNotesLoading',false);
      commit('setCurrentTicketNotesError', true);
      dispatch('alerts/setAlert', {type: 'error',message: err.response.data.message}, { root: true });
    }
  },
  async addTicketNotesByID({ commit, dispatch }, {tid, data}) {
    commit('CREATE_TICKET_NOTE_BEGIN');
    try {
      await ticketsAPI.addTicketNotesByID(tid, data);
      commit('CREATE_TICKET_NOTE_SUCCESS');
      dispatch('tickets/fetchTicketNotesByID', tid, { root: true });
      dispatch('alerts/setAlert', {type: 'success', message: 'Ticket note added successfully!'}, { root: true });
    } catch(err) {
      commit('CREATE_TICKET_NOTE_ERROR', err.response.data);
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data.message}, { root: true });
    }
  },
  async updateTicketData({ dispatch, commit }, {id,data}) {
    try {
      commit('setTicketUpdateLoading',true);
      let res = await ticketsAPI.updateTicketData(id,data);
      if(res.status===200){
        commit('setCurrentTicket', res.data);
        dispatch('alerts/setAlert', {type: 'success',message: 'Ticket updated successfully!'}, { root: true });
        return true;
      }else{
        commit("setTicketUpdateLoading", false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    } catch(err) {
      commit('setTicketUpdateLoading',false);
      dispatch('alerts/setAlert', {type: 'error',message: err.response.data.message}, { root: true });
      return false;
    }
  },
  async createNewTicket({ dispatch, commit }, {pid,data}) {
    try {
      commit('setTicketUpdateLoading',true);
      let res = await ticketsAPI.createNewTicket(pid,data);
      commit('setNewTicketID',res.data.id);
      dispatch('alerts/setAlert', {type: 'success',message: 'Ticket created successfully!'}, { root: true });
      return true;
    } catch(err) {
      commit('setTicketUpdateLoading',false);
      dispatch('alerts/setAlert', {type: 'error',message: err.response.data.message}, { root: true });
      return false;
    }
  },
  resetTicketStore({ commit }) {
    commit("RESET_TICKET_STORE");
  }
};

const getters = {
  getTicketsConfigs: (state) => state.ticketsConfig,
  getTickets: state => {
    return state.tickets.map(e=>{return{
      id: e.id,
      product_id: e.product_id,
      type: e.kind,
      status: e.status,
      agent: e.agent,
      created_by: e.created_by,
      escalation_agent: e.escalation_agent,
      department: e.team,
      creation_timestamp: e.creation_timestamp,
      date_assigned: e.assigned,
      last_changed: e.last_changed,
      age: `${moment(new Date()).diff(moment(e.creation_timestamp), 'days')} days`,
      next_follow_up_date: e.next_follow_up_date,
      is_escalation: e.status==='escalation',
      description: e.description,
      product_kind: e.product_kind,
      urlsafe_id: e.urlsafe_id,
      cause_summary: e.cause_summary,
      outcome: e.outcome,
      supplier_ticket_id: e.supplier_ticket_id,
    }});
  },
  getTicketsLoading: state => state.ticketsLoading,
  getTicketUpdateLoading: state => state.ticketUpdateLoading,
  getTicketHistory: state => {
    return (state.currentTicket.history!==null&state.currentTicket.history!==undefined)?state.currentTicket.history.reverse():[];
  },
  getTicketNotes: state => {
    return (state.currentTicketNotes!==undefined)?state.currentTicketNotes.reverse().map(e=>{
      return {
        user: e.user,
        note: e.note,
        creation_timestamp: e.creation_timestamp,
      }
    }):[];
  },
  getCurrentTicketNotesError: (state) => state.currentTicketNotesError,
  getTicketTypes: () => {
    return ['Telco Provisioning','Telco Billing','Telco Service','Telco Fault','Lodge fault','Fault Call Plan','Static IP','Call features','Phone line','Broadband','Modem','Dates','Provisioning checks','Billing','Checks','VoIP COT/COP','Features','Telco COT/COP','Renewals/Fibre Upgrades','VoIP Fault','VoIP Feature','VoIP Consultation','VoIP Onboarding','VoIP Number Transfers','NPS survey','Complaint email','CSAT survey','DART tasks','Ombudsman','1 Star','Order Delay','Provisioning Delay','Failed Engineer'].sort();
  },
  getTicketTeams: () => {
    return ['Accounts - Billing','Accounts - Finance','Credit Control','DART','FrontLine CS','Retentions','Sales','Telco Faults','Telco Provisioning','VoIP Care','VoIP Onboarding'].sort();
  },
  getTicketCauses: () => {
    return [
      {text: 'Agent', value: 'AGENT'}, 
      {text: 'Product', value: 'PRODUCT'}
    ];
  },
  getTicketCause: () => (cause) => {
    switch(cause) {
      case 'AGENT':
        return 'Agent';
      case 'PRODUCT':
        return 'Product';
      default:
        return '';
    }
  },
  getAddTicketNoteLoading: (state) => state.isAddTicketNoteLoading,
  getAddTicketNoteError: (state) => state.isAddTicketNoteError,

  getCurrentTicket: state => state.currentTicket,
  getLinkedTickets: state => {
    if(state.currentTicket.ticket_links) {
      return state.currentTicket.ticket_links.reduce((acc, obj) => {
        if(state.currentTicket.association_status.toLowerCase() === 'parent') {
          acc.push(obj.child_ticket);
        }

        if(state.currentTicket.association_status.toLowerCase() === 'child') {
          acc.push(obj.parent_ticket);
        }
        return acc;
      }, []);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
